import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";
import config from "../../config";

interface AccountCreationRequests {
  email: string;
  serialHash: string;
}

export function useAccountCreation(callbacks: QueryCallbacks<void>) {
  return useMutation({
    mutationKey: ["accountCreation"],
    mutationFn: async (accountCreationRequests: AccountCreationRequests) => {
      const response = await fetch(`${config.apiGateway.UTP2_API}/api/accounts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(accountCreationRequests),
      });

      if (!response.ok) {
        throw response;
      }
    },
    ...callbacks,
  });
}
